var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.918 16.862v-5.2c0-2.73 0-4.094-.531-5.137a4.874 4.874 0 0 0-2.13-2.13c-1.043-.532-2.408-.532-5.138-.532h-10.4c-2.73 0-4.095 0-5.137.532a4.875 4.875 0 0 0-2.13 2.13c-.532 1.043-.532 2.408-.532 5.138V28.56c0 2.73 0 4.096.531 5.138a4.875 4.875 0 0 0 2.13 2.13c1.043.532 2.409.532 5.139.532h5.2m.812-17.874H13.42m1.625 6.5H13.42m12.999-13h-13m14.62 12.725c-1.3-1.477-3.466-1.875-5.094-.522-1.629 1.352-1.858 3.613-.58 5.213 1.28 1.6 5.674 5.333 5.674 5.333s4.395-3.733 5.674-5.333c1.278-1.6 1.077-3.875-.58-5.213-1.655-1.339-3.794-.956-5.094.521Z",
  stroke: "currentColor",
  strokeWidth: 3.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgFileHeart;